var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    on: {
      "dragover": function dragover($event) {
        $event.preventDefault();
        return _vm.startDrag.apply(null, arguments);
      }
    }
  }, [_vm.isDrag ? _c('div', {
    staticStyle: {
      "z-index": "1",
      "top": "0",
      "left": "0",
      "position": "absolute",
      "height": "100%",
      "width": "100%",
      "background-color": "rgba(200,200,200,0.5)"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    on: {
      "dragleave": function dragleave($event) {
        $event.preventDefault();
        return _vm.endDrag.apply(null, arguments);
      },
      "drop": function drop($event) {
        $event.preventDefault();
        return _vm.onFileDrop($event);
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "transform": "scale(300%)"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.prependIcon) + " ")])], 1)]) : _vm._e(), _c('v-form', {
    ref: "signDocumentForm",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [!_vm.isUpdate ? _c('file-input', {
    ref: "fileInput",
    attrs: {
      "maxFileSizeInMb": _vm.maxFileSizeInMb,
      "value": _vm.createDocumentDto.file,
      "accept": "application/pdf, .pdf",
      "label": _vm.$t('sign.SignDocumentForm.file') + ' *',
      "placeholder": _vm.$t('sign.SignDocumentForm.placeholder'),
      "rules": _vm.maxSizeRule,
      "readonly": _vm.disabled,
      "outlined": ""
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.createDocumentDto, "file", $event);
      },
      "change": _vm.onChange
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('sign.SignDocumentForm.title') + ' *',
      "hint": _vm.$t('sign.SignDocumentForm.titleHint'),
      "outlined": ""
    },
    model: {
      value: _vm.createDocumentDto.title,
      callback: function callback($$v) {
        _vm.$set(_vm.createDocumentDto, "title", $$v);
      },
      expression: "createDocumentDto.title"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": _vm.$t('sign.SignDocumentForm.description'),
      "hint": _vm.$t('sign.SignDocumentForm.descriptionHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.createDocumentDto.description,
      callback: function callback($$v) {
        _vm.$set(_vm.createDocumentDto, "description", $$v);
      },
      expression: "createDocumentDto.description"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.showFolder ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('sign.SignDocumentForm.folder'),
      "outlined": ""
    },
    on: {
      "blur": _vm.removeWhiteSpace
    },
    model: {
      value: _vm.createDocumentDto.folder,
      callback: function callback($$v) {
        _vm.$set(_vm.createDocumentDto, "folder", $$v);
      },
      expression: "createDocumentDto.folder"
    }
  }) : _vm._e(), _vm.showIsTemplate ? _c('custom-field-boolean', {
    attrs: {
      "customField": {
        label: _vm.$t('sign.SignDocumentForm.template')
      }
    },
    model: {
      value: _vm.createDocumentDto.isTemplate,
      callback: function callback($$v) {
        _vm.$set(_vm.createDocumentDto, "isTemplate", $$v);
      },
      expression: "createDocumentDto.isTemplate"
    }
  }) : _vm._e(), _vm.partner.partnerType === _vm.PartnerTypeEnum.BROKER ? _c('v-select', {
    attrs: {
      "label": _vm.$t('objects.document.isInternal'),
      "items": [true, false],
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(item ? "mdi-lock-outline" : "mdi-share-variant-outline") + " ")]), _vm._v(" " + _vm._s(_vm.$t("sign.DocumentTable.".concat(item))) + " ")], 1)];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTable.".concat(item))) + " ")];
      }
    }], null, false, 2175612016),
    model: {
      value: _vm.createDocumentDto.isInternal,
      callback: function callback($$v) {
        _vm.$set(_vm.createDocumentDto, "isInternal", $$v);
      },
      expression: "createDocumentDto.isInternal"
    }
  }) : _vm._e(), _c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.TAG,
      "field": _vm.partnerId
    }
  }, [_c('select-tags', {
    attrs: {
      "value": _vm.createDocumentDto.tags,
      "resource": _vm.ResourceEnum.DOCUMENT,
      "partnerId": _vm.partnerId,
      "prependIcon": "mdi-tag-multiple-outline"
    },
    on: {
      "input": function input(tags) {
        _vm.createDocumentDto.tagIds = tags.map(function (tag) {
          return tag.id;
        });
        _vm.createDocumentDto.tags = tags;
      }
    }
  })], 1)], 1)], 1), !_vm.document && !_vm.hideButton ? _c('v-btn', {
    staticClass: "mt-4 mr-4",
    attrs: {
      "hidden": _vm.hideButton,
      "loading": _vm.isLoading,
      "color": "primary",
      "large": "",
      "disabled": !_vm.valid,
      "data-test-form-submit": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.SignDocumentForm.submit")) + " ")]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }